<template>
	
 <nav class="pagination is-rounded  is-centered" role="navigation" aria-label="pagination">
  <ul class="pagination-list">
      <li>
      <button 
      class="pagination-previous has-text-weight-bold" 
      type="button"
      @click="OnNextPage({page : 'Prev'})"
      href="#">Previous Posts</button>
      </li>
      <li>
      <button 
      type="button"
      class="pagination-link button has-text-weight-bold is-primary">Page 2 of 5</button>
      </li>
      <li>
      <button 
      type="button"
      class="pagination-next has-text-weight-bold" 
      @click="OnNextPage({page : 'Next'})"
      href="#">Next Posts</button>
      </li>
  </ul>
</nav>

</template>
<script>
	
	export default {
		props:{
			OnNextPage : {
				type : Function,
				requierd : true
			}
		}
	}
</script>